import AccessControl from '@modules/auth/AccessControl'
import moment from 'moment'
import React, { Component } from 'react'
import { Trans, withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { compose } from 'redux'
import actionCreators from 'redux-form/es/actions'
import { history } from '@services/History'
import { customerFullName } from '@utilities/fullName'
import '../MD.Table.scss'

class CustomerIndexTable extends Component {
  onClickRelatedRooms = (customer) => {
    const { dispatch } = this.props

    dispatch(
      actionCreators.initialize('adminRoomFilters', {
        customerFilter: { ...customer, name: customer.firstname },
        startDate: moment(customer.created_at).toDate(),
        endDate: moment().toDate(),
        page: 1,
      })
    )

    history.push('/room')
  }

  render() {
    const { customers } = this.props

    return (
      <table className="md-table">
        <thead>
          <tr>
            <th>
              <Trans>Nombre</Trans>
            </th>
            <th width={35} />
            <th className="col-large">
              <Trans>Token</Trans>
            </th>
            <th className="col-large">
              <Trans>Email</Trans>
            </th>
            <th>
              <Trans>Teléfono</Trans>
            </th>
            <th>
              <Trans>DNI</Trans>
            </th>
            <AccessControl>
              <th>
                <Trans>Ver Chats</Trans>
              </th>
              <th>
                <Trans>Ver su Lista</Trans>
              </th>
              <th>
                <Trans>Compañía</Trans>
              </th>
            </AccessControl>
          </tr>
        </thead>
        <tbody>
          {customers.map((customer) => (
            <tr key={customer.hash}>
              <td className="col-center">
                <Link to={`customers/${customer.hash}`}>{customerFullName(customer)}</Link>
              </td>
              <td className="col-center vip-col">
                {customer.vip ? (
                  <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M6.17902 0.0940767C6.09525 -0.0313662 5.90474 -0.0313582 5.82097 0.0940688L4.15638 3.3316L0.158872 4.05188C0.00899622 4.08973 -0.0498864 4.2641 0.04823 4.37949L2.50062 7.04033L2.21096 10.7834C2.20208 10.9322 2.35625 11.0399 2.50062 10.9858L6.12977 9.59372L9.4994 10.9858C9.64374 11.0399 9.79794 10.9322 9.78905 10.7834L9.3127 6.93382L11.9517 4.37949C12.0499 4.2641 11.991 4.08973 11.8411 4.05188L8.03769 3.276L6.17902 0.0940767Z"
                      fill="#01A8E7"
                    />
                  </svg>
                ) : null}
              </td>
              <td>
                <i className="icon fa fa-clipboard" onClick={() => navigator.clipboard.writeText(customer.token)} />
                <span className="text">{customer.token}</span>
              </td>
              <td className="col-center">{customer.email}</td>
              <td className="col-center">{customer.mobile_phone}</td>
              <td className="col-center">{customer.nid_number}</td>
              <AccessControl>
                <td
                  className="col-center"
                  style={{ cursor: 'pointer' }}
                  onClick={() => this.onClickRelatedRooms(customer)}
                >
                  <i className="fas fa-comments" />
                </td>
                <td className="col-center" style={{ cursor: 'pointer' }}>
                  <i className="fas fa-user-secret" />
                </td>
                <td className="col-center">{customer.company_name}</td>
              </AccessControl>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }
}

export default compose(withTranslation(), connect())(CustomerIndexTable)
